import { Box, useTheme } from '@mui/material'

/**
 * The selection indicator on a §34 selectable card.
 *
 * Extracted on its THIRD hand-roll (§36): the Features page's activation-trigger
 * cards and Installation's `ScanDestinationPicker` each drew this by hand, and the
 * activation-trigger MODAL was about to draw a fourth — except it had reached for
 * MUI's `<Radio>` instead, which is why the same decision rendered two different
 * ways on two surfaces a click apart.
 *
 * Deliberately NOT a MUI `Radio`. The house pattern is an 18px ring that fills with
 * the brand colour when chosen, sized and coloured to sit with `body2` card titles;
 * MUI's radio brings its own palette, ripple and 42px touch target, none of which
 * match. It is also `aria-hidden`, because the card that owns it already carries
 * `role="radio"` + `aria-checked` — announcing it twice is worse than not at all.
 *
 * ⚠️ Features and ScanDestinationPicker still hand-roll their own. They are not
 * migrated here because doing so means re-verifying two settings surfaces this
 * change has no other reason to touch; migrate each as it is next edited.
 */
export const SelectionDot = ({ selected }: { selected: boolean }) => {
  const theme = useTheme()
  return (
    <Box
      aria-hidden
      sx={{
        width: 18,
        height: 18,
        borderRadius: '50%',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${
          selected ? theme.palette.brand[500] : theme.palette.primary[100]
        }`,
      }}
    >
      {selected && (
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: theme.palette.brand[500],
          }}
        />
      )}
    </Box>
  )
}
